import React, { Component } from 'react'
import grid from './grid.module.css'

class RowBlock extends Component {
   makeFullClasses() {

      const { className } = this.props

      let classes = []
      classes.push(grid.rowBlock)

      if(className)
      classes.push(className)

      return classes.join(' ')
   }

   render() {
      return (
         <div className={this.makeFullClasses()} style={{ ...this.props.style }}>
            {this.props.children}
         </div>
      )
   }
}


export default RowBlock


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/RowBlock.js